<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00037.installation.celluleQRCode.titre' | translate"
      [description]="
        'P00037.installation.celluleQRCode.description' | translate
      "
    >
    </app-header-configuration>

    <app-label-configuration
      [titleListe]="'P00037.installation.celluleQRCode.ref' | translate"
      [liste]="P00037CellModel"
      [value]="value ?? 0"
      (onPress)="selectValue($event)"
    >
    </app-label-configuration>

    <app-label-description
      [description]="
        'P00037.installation.celluleQRCode.ref.description' | translate
      "
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button
        color="primary"
        expand="block"
        (click)="onSubmit()"
        [disabled]="value === null || value === 0"
      >
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
